<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>When</th>
        <th>Activity</th>
        <th>Qty</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="log in product.log" :key="log.id">
        <td style="width: 300px;">{{ calendar(log.created_at) }}</td>
        <td style="width: 200px;">{{ log.reason }}</td>
        <td>{{ log.qty }}</td>
      </tr>
      <tr v-if="!product.log || product.log.length == 0">
        <td colspan="3" class="text-center p-4">
          No inventory transactions available for this product.
        </td>
      </tr>                  
    </tbody>              
  </table>   
</template>
<script>

import moment from 'moment'

export default {
  name: 'log-tab',
  props: ['product'],

  methods: {
    calendar(date) {
      return moment(date).calendar()
    }
  }
}
</script>
